import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'src/app/services/utils';

const maxTime = 900000;
@Injectable()
export class HttpCacheService {

    private static CacheFactory: any[] = [];
    cache = new Map();

    public static SetCache(key, value) {
        this.CacheFactory[key] = value;
    }

    public static GetCache(key): any {
            return this.CacheFactory[key];
        }

    public static ClearCacheKey(key) {
        this.CacheFactory.splice(this.CacheFactory.indexOf([key]), 1);
    }

    getFromLocalStorage(key): any {
        return localStorage.getItem(key);
    }

    putInLocalStoarage(key, value) {
        localStorage.setItem(key, value);
    }

    getFromSessionStorage(key): any {
            return sessionStorage.getItem(key);
    }

    putInSessionStoarage(key, value) {
        sessionStorage.setItem(key, value);
    }
    deleteFromLocalStoarage(key) {
        localStorage.removeItem(key);
    }
    deleteFromSessionStoarage(key) {
        sessionStorage.removeItem(key);
    }
    clearLocalStorage() {
        localStorage.clear();
    }
    clearSessionStorage() {
        sessionStorage.clear();
    }

    get(req: HttpRequest<any>): HttpResponse<any> | undefined {
    const url = req.urlWithParams;
    const cached = this.cache.get(url);

    if (!cached) {
      return null;
    }
    const isExpired = cached.lastRead < (Date.now() - maxTime);
    if (isNullOrUndefined(cached || cached.response) || isExpired) {
        return null;
    } else {
        return cached.response;
    }
  }

    put(req: HttpRequest<any>, response: HttpResponse<any>): void {
    const expired = Date.now() - maxTime;
    this.cache.forEach((expiredEntry) => {
      if (expiredEntry.lastRead < expired) {
        this.cache.delete(expiredEntry.url);
      }
    });
    const url = req.urlWithParams;
    const entry = { url, response, lastRead: Date.now() };
    this.cache.set(url, {...entry});
  }
}
